import { Card } from "../models/Card";
import { Deck } from "../models/Deck";
import CardView from "./CardView";

export default function FavoriteCards(props: { deck: Deck, selectedCard: Card|null, removeFavoriteCard: (card: Card) => any, unmarkFavoriteCard: (card: Card) => any, onClicked: (card?: Card) => any; }) {
    return <>
        {
            props.deck.favoriteCards.map((card) =>
                <CardView
                    key={card.uuid}
                    card={card}
                    isFavorite={true}
                    isCardSelected={ card.uuid === props.selectedCard?.uuid }
                    onRemoveCard={props.removeFavoriteCard}
                    onMarkFavoriteCard={null}
                    onUnmarkFavoriteCard={props.unmarkFavoriteCard}
                    onClicked={props.onClicked} />
            )
        }
    </>;
};
